import { CONSTANT_TABLE } from '@/components/Table/list-table/interface';
import { path } from '@/routes/paths';
import { Chip } from '@mui/material';
import React from 'react';
import { formatDateWithTime, translates } from '@/utils';
import { LinkLabel } from '../components/common/typesRowLabel';

export const TABLE_HEAD_RESERVATION: CONSTANT_TABLE[] = [
  { id: 'name', label: translates.name, align: 'left',
    wrapComponent: (value: string, id: string) => <LinkLabel value={value} id={id} />
  },
  { id: 'document', label: translates.document, align: 'left' },
  { id: 'phone', label: translates.phone, align: 'left' },
  { id: 'email', label: translates.email, align: 'left' },
  { id: 'date', label: translates.bookingDate, align: 'center' },
  { id: 'time', label: translates.time, align: 'center' },
  { id: 'attendees', label: translates.assistants, align: 'center', width: 180 },
  {
    id: 'message',
    label: 'mensaje',
    align: 'left',
  },
  { id: 'plan', label: translates.plan, align: 'center', width: 180 },
  { id: 'createAt', label: translates.createAt, align: 'center', width: 180 , wrapComponent : (value) => value ? formatDateWithTime(value) : ''},
  {
    id: 'status',
    label: translates.status,
    align: 'center',
    wrapComponent: (value: string) => <Chip label={value} />,
  },

  { id: '', disableSort: true },
];

export enum STATUS {
  CREATED = 'created',
  PAID = 'paid',
  CANCEL = 'cancel',
  CLOSED = 'closed',
  REOPEN = 're_open',
}
export const PATH_RESERVATION = (ROOTS_DASHBOARD: string) => ({
  root: path(ROOTS_DASHBOARD, '/reservation'),
  list: path(ROOTS_DASHBOARD, '/reservation/list'),
  view: (name: number) => path(ROOTS_DASHBOARD, `/providers/${name}`),
  edit: (name: number) => path(ROOTS_DASHBOARD, `/providers/${name}/edit`),
});

export const LABELS_RESERVATION: Record<string, string>[] = [
  {
    label: 'Reservado por :',
    key: 'name',
  },
  {
    label: 'Correo :',
    key: 'email',
  },
  {
    label: 'Documento :',
    key: 'document',
  },
  {
    label: 'Telefono :',
    key: 'phone',
  },
  {
    label: 'Fecha de la Reserva :',
    key: 'date',
  },
  {
    label: 'Hora Reserva :',
    key: 'time',
  },
  {
    label: 'Cantidad Personas :',
    key: 'attendees',
  },
  {
    label: 'Observaciones :',
    key: 'message',
  },
  {
    label: 'Fecha de creacion :',
    key: 'createAt',
  },

  {
    label: 'Estado :',
    key: 'status',
  },
];

export const LABEL_PLAN = [
  {
    label: 'Tipo de Plan :',
    key: 'name',
  },
  {
    label: 'Detalles del plan :',
    key: 'description',
  },
  {
    label: 'Precio del Plan:',
    key: 'price',
  },
];
